import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '@/store/store'

// 0 = Idea, 1 = Creating, 2 = Editing, 3 = Publish
type StepperState = {
  activeStep: number
}

const initialState: StepperState = {
  activeStep: 0, // Default to "Idea" phase
}

const stepperSlice = createSlice({
  name: 'stepper',
  initialState,
  reducers: {
    // Action to set the current step
    setCreationStep: (state, action: PayloadAction<number>) => {
      state.activeStep = action.payload
    },
    // Action to reset the step when leaving the flow
    resetCreationStep: (state) => {
      state.activeStep = 0
    },
  },
})

export const { setCreationStep, resetCreationStep } = stepperSlice.actions

export const selectActiveStep = (state: RootState) => state.stepper.activeStep

export default stepperSlice.reducer
